import { mapGradeCodeToGradeParamId, slugifySubject } from "./routeUtil";

export const getBaseRoute = () => {
  const basePath = import.meta.env.BASE_URL || "/learning/";
  return basePath;
};

export const getHomeRoute = (gradeCode: number) => {
  const gradeId = mapGradeCodeToGradeParamId(gradeCode);
  return `/learning/${gradeId}`;
};

export const getAchievementsRoute = (gradeCode: number) => {
  const gradeId = mapGradeCodeToGradeParamId(gradeCode);
  return `/learning/${gradeId}/achievements`;
};

export const getTermsRoute = (gradeCode: number) => {
  const gradeId = mapGradeCodeToGradeParamId(gradeCode);
  return `/learning/${gradeId}/terms`;
};

export const getTermRoute = (gradeCode: number, term: string) => {
  const gradeId = mapGradeCodeToGradeParamId(gradeCode);
  const termId = `term-${term}`;

  return `/learning/${gradeId}/terms/${termId}`;
};

export const getWeekRoute = (gradeCode: number, term: string, week: string) => {
  const gradeId = mapGradeCodeToGradeParamId(gradeCode);
  const termId = `term-${term}`;
  const weekId = `week-${week}`;

  return `/learning/${gradeId}/terms/${termId}/${weekId}`;
};

export const getAccountRoute = (gradeCode: number) => {
  const gradeId = mapGradeCodeToGradeParamId(gradeCode);
  return `/learning/${gradeId}/account`;
};

export const getMaterialsRoute = (gradeCode: number) => {
  const gradeId = mapGradeCodeToGradeParamId(gradeCode);
  return `/learning/${gradeId}/materials`;
};

export const getLessonRoute = (
  gradeCode: number | undefined,
  term: string,
  week: string,
  lessonSlug: string,
  lesson: string,
  step?:
    | "introduction"
    | "learn"
    | "practise"
    | "apply"
    | "reflection"
    | "summary"
) => {
  const gradeId = mapGradeCodeToGradeParamId(gradeCode as number);
  const termId = `term-${term}`;
  const weekId = `week-${week}`;
  const lessonId = lesson;

  return step
    ? `/learning/${gradeId}/terms/${termId}/${weekId}/${lessonSlug}/lesson/${lessonId}/${step}`
    : `/learning/${gradeId}/terms/${termId}/${weekId}/${lessonSlug}/lesson/${lessonId}`;
};

export const getLessonResultsRoute = (
  gradeCode: number | undefined,
  term: string,
  week: string,
  lessonSlug: string,
  lesson: string
) => {
  const gradeId = mapGradeCodeToGradeParamId(gradeCode as number);
  const termId = `term-${term}`;
  const weekId = `week-${week}`;
  const lessonId = lesson;

  return `/learning/${gradeId}/terms/${termId}/${weekId}/${lessonSlug}/lesson/${lessonId}/apply/results`;
};

export const getSubjectListRoute = (gradeCode: number | undefined) => {
  const gradeId = mapGradeCodeToGradeParamId(gradeCode as number);
  return `/learning/${gradeId}/subjects`;
};

export const getAssignmentsRoute = (
  gradeCode: number,
  term?: string | number
) => {
  const gradeId = mapGradeCodeToGradeParamId(gradeCode);
  return term
    ? `/learning/${gradeId}/assignments/term/${term}`
    : `/learning/${gradeId}/assignments`;
};

export const getAssignmentDetailRoute = (
  gradeCode: number,
  term: number | string,
  subject: string,
  assignmentId: string
) => {
  const gradeId = mapGradeCodeToGradeParamId(gradeCode);
  const subjectSlug = slugifySubject(subject);
  return `/learning/${gradeId}/assignments/term-${term}/${subjectSlug}/${assignmentId}`;
};

export const getSubjectRoute = (
  gradeCode: number | undefined,
  subjectSlug: string,
  term: string
) => {
  const gradeId = mapGradeCodeToGradeParamId(gradeCode as number);
  const termId = `term-${term}`;

  return `/learning/${gradeId}/subjects/${subjectSlug}/${termId}`;
};